module.exports = "<tr> <td> <span class=q-boldest>Estimated Sub-Total</span> </td> <td></td> <td></td> <td class=q-text-right> <span class=\"q-boldest sub-total-currency\">{%- subtotal %}</span> </td> </tr>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/asns/ServicesTab/html/reviewSubTotalRow.html
// module id = 1221
// module chunks = 1